import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ACADEMICO = 'ALL_ACADEMICO';
export const ACTIVO_ACADEMICO = 'ACTIVO_ACADEMICO';
export const ALERT_VIEW_ACADEMICO = 'ALERT_VIEW_ACADEMICO';
export const LOADING_ALL_ACADEMICO = 'LOADING_ALL_ACADEMICO';
export const PARAMS_ACADEMICO = 'PARAMS_ACADEMICO';

const initialState = {
  all: [],
  activo: null,
  message: null,
  loadingAll: false,
  params: {},
};

export const panelAcademicoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ACADEMICO:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_ACADEMICO:
      return {
        ...state,
        activo: action.payload,
      };
    case ALERT_VIEW_ACADEMICO:
      return {
        ...state,
        alertView: action.payload,
      };
    case LOADING_ALL_ACADEMICO:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ACADEMICO:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
